import React, { CSSProperties, useEffect, useState } from 'react';

import { getDaysFrequencyPoll, getFrequencies, getFrequencyPoll, allNullFrequencyValues } from '../../../services/getPollAttribute';

import { useTranslation } from 'react-i18next';

import InputSelect from '../../UI/InputSelect/InputSelect';
import Modal from '../../UI/Modal/Modal';
import FrequencySelector from '../../UI/FrequencySelector/FrequencySelector';

import { OptionsSelect } from '../../../interfaces/Input';
import { PollFrequency } from '../../../interfaces/Poll';

interface Props {
    pollFrequency: PollFrequency
    handleChangeFreq: (freq: PollFrequency) => void
    style?: CSSProperties
}

const SelectFrequency: React.FC<Props> = ({ pollFrequency, handleChangeFreq, style }) => {

    const { t } = useTranslation();
    const [showFrequencySelector, setShowFrequencySelector] = useState(false);

    const FREQ_OPTIONS = getFrequencies().map((freq) => ({ id: freq, name: t(freq) }));

    const defaultFreq = allNullFrequencyValues(pollFrequency) ? '' : getFrequencyPoll(pollFrequency);
    const [selectValue, setSelectValue] = useState(defaultFreq);

    const handleChange = (option: OptionsSelect) => {
        if (typeof option.id === 'number') return;
        if (option.id === 'custom') setShowFrequencySelector(true);
        else handleChangeFreq({
            frecuency: getDaysFrequencyPoll(option.id),
            monthly_frequency_day: null,
            semanal_frequency: null,
            frequency_duration: null
        });
        setSelectValue(option.id);
    };

    useEffect(() => {
        setSelectValue(defaultFreq);
    }, [defaultFreq]);

    return (
        <>
            <InputSelect
                options={FREQ_OPTIONS}
                value={t(selectValue)}
                label={''}
                simpleStyles
                style={style}
                onChange={handleChange}
            />
            <Modal
                show={showFrequencySelector}
                setShowModal={setShowFrequencySelector}
                secondModal
            >
                <FrequencySelector
                    frequency={pollFrequency}
                    onCancel={() => setShowFrequencySelector(false)}
                    onConfirm={handleChangeFreq}
                    setShow={setShowFrequencySelector}
                />
            </Modal>
        </>
    );
};

export default SelectFrequency;